import Swal from 'sweetalert2';
export default async function swal2({ text, title, input, confirmButtonText, denyButtonText, cancelButtonText, inputPlaceholder, icon, deleteMode, className, width = '45em', preConfirm, didOpen, html, allowOutsideClick = true, showConfirmButton = !!confirmButtonText, }) {
    return await Swal.fire({
        text,
        input,
        inputPlaceholder,
        title,
        icon,
        width,
        html,
        denyButtonText,
        cancelButtonText,
        confirmButtonText,
        preConfirm,
        didOpen,
        allowOutsideClick,
        showConfirmButton,
        showDenyButton: !!denyButtonText,
        showCancelButton: !!cancelButtonText,
        reverseButtons: true,
        buttonsStyling: false,
        customClass: {
            container: className,
            cancelButton: 'btn-rounded btn btn-link mr-5 legitRipple',
            confirmButton: deleteMode
                ? 'btn btn-danger legitRipple btn-rounded btn btn-primary'
                : 'btn btn-primary legitRipple btn-rounded btn btn-primary',
            denyButton: 'btn btn-danger legitRipple btn-rounded btn btn-primary',
        },
    });
}
export { Swal };
